Compiled with problems:
￼×
ERROR in src/utils/__tests__/seoUtils.test.ts:7:18
TS2304: Cannot find name 'jest'.
     5 |   title: 'Original Title',
     6 |   head: {
  >  7 |     appendChild: jest.fn(),
       |                  ^^^^
     8 |     removeChild: jest.fn()
     9 |   },
    10 |   createElement: jest.fn(() => ({
ERROR in src/utils/__tests__/seoUtils.test.ts:8:18
TS2304: Cannot find name 'jest'.
     6 |   head: {
     7 |     appendChild: jest.fn(),
  >  8 |     removeChild: jest.fn()
       |                  ^^^^
     9 |   },
    10 |   createElement: jest.fn(() => ({
    11 |     setAttribute: jest.fn(),
ERROR in src/utils/__tests__/seoUtils.test.ts:10:18
TS2304: Cannot find name 'jest'.
     8 |     removeChild: jest.fn()
     9 |   },
  > 10 |   createElement: jest.fn(() => ({
       |                  ^^^^
    11 |     setAttribute: jest.fn(),
    12 |     getAttribute: jest.fn(),
    13 |     id: '',
ERROR in src/utils/__tests__/seoUtils.test.ts:11:19
TS2304: Cannot find name 'jest'.
     9 |   },
    10 |   createElement: jest.fn(() => ({
  > 11 |     setAttribute: jest.fn(),
       |                   ^^^^
    12 |     getAttribute: jest.fn(),
    13 |     id: '',
    14 |     type: '',
ERROR in src/utils/__tests__/seoUtils.test.ts:12:19
TS2304: Cannot find name 'jest'.
    10 |   createElement: jest.fn(() => ({
    11 |     setAttribute: jest.fn(),
  > 12 |     getAttribute: jest.fn(),
       |                   ^^^^
    13 |     id: '',
    14 |     type: '',
    15 |     textContent: ''
ERROR in src/utils/__tests__/seoUtils.test.ts:17:18
TS2304: Cannot find name 'jest'.
    15 |     textContent: ''
    16 |   })),
  > 17 |   querySelector: jest.fn(() => null)
       |                  ^^^^
    18 | }
    19 |
    20 | // Mock window.location
ERROR in src/utils/__tests__/seoUtils.test.ts:27:1
TS2304: Cannot find name 'global'.
    25 |
    26 | // Setup global mocks
  > 27 | global.document = mockDocument as any
       | ^^^^^^
    28 | global.window = { location: mockLocation } as any
    29 |
    30 | describe('SEOManager', () => {
ERROR in src/utils/__tests__/seoUtils.test.ts:28:1
TS2304: Cannot find name 'global'.
    26 | // Setup global mocks
    27 | global.document = mockDocument as any
  > 28 | global.window = { location: mockLocation } as any
       | ^^^^^^
    29 |
    30 | describe('SEOManager', () => {
    31 |   let seoManager: SEOManager
ERROR in src/utils/__tests__/seoUtils.test.ts:30:1
TS2593: Cannot find name 'describe'. Do you need to install type definitions for a test runner? Try `npm i --save-dev @types/jest` or `npm i --save-dev @types/mocha` and then add 'jest' or 'mocha' to the types field in your tsconfig.
    28 | global.window = { location: mockLocation } as any
    29 |
  > 30 | describe('SEOManager', () => {
       | ^^^^^^^^
    31 |   let seoManager: SEOManager
    32 |
    33 |   beforeEach(() => {
ERROR in src/utils/__tests__/seoUtils.test.ts:33:3
TS2304: Cannot find name 'beforeEach'.
    31 |   let seoManager: SEOManager
    32 |
  > 33 |   beforeEach(() => {
       |   ^^^^^^^^^^
    34 |     jest.clearAllMocks()
    35 |     seoManager = new SEOManager()
    36 |   })
ERROR in src/utils/__tests__/seoUtils.test.ts:34:5
TS2304: Cannot find name 'jest'.
    32 |
    33 |   beforeEach(() => {
  > 34 |     jest.clearAllMocks()
       |     ^^^^
    35 |     seoManager = new SEOManager()
    36 |   })
    37 |
ERROR in src/utils/__tests__/seoUtils.test.ts:38:3
TS2593: Cannot find name 'test'. Do you need to install type definitions for a test runner? Try `npm i --save-dev @types/jest` or `npm i --save-dev @types/mocha` and then add 'jest' or 'mocha' to the types field in your tsconfig.
    36 |   })
    37 |
  > 38 |   test('should set comprehensive SEO<template>
  <LegalPageLayout
    title="Privacy Policy"
    :last-updated="lastUpdated"
    :show-table-of-contents="true"
  >
    <div class="privacy-policy-content">
      <section id="introduction" role="region" aria-labelledby="introduction-heading">
        <h2 id="introduction-heading">Introduction</h2>
        <p>
          Welcome to WallpaperHub. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services. We are committed to protecting your privacy and ensuring transparency about our data practices.
        </p>
        <p>
          By using our service, you agree to the collection and use of information in accordance with this policy. If you do not agree with our policies and practices, please do not use our service.
        </p>
      </section>

      <section id="information-we-collect" role="region" aria-labelledby="information-we-collect-heading">
        <h2 id="information-we-collect-heading">Information We Collect</h2>
        
        <h3 id="personal-information">Personal Information</h3>
        <p>We may collect personal information that you voluntarily provide to us when you:</p>
        <ul>
          <li>Create an account or register for our services</li>
          <li>Upload wallpapers or other content</li>
          <li>Contact us for support or inquiries</li>
          <li>Subscribe to our newsletter or marketing communications</li>
          <li>Participate in surveys or promotional activities</li>
        </ul>
        <p>This information may include:</p>
        <ul>
          <li>Name and email address</li>
          <li>Profile information and preferences</li>
          <li>Content you upload (wallpapers, comments, ratings)</li>
          <li>Communication preferences</li>
        </ul>

        <h3 id="automatically-collected-information">Automatically Collected Information</h3>
        <p>When you visit our website, we automatically collect certain information about your device and usage patterns:</p>
        <ul>
          <li>IP address and general location information</li>
          <li>Browser type and version</li>
          <li>Operating system and device information</li>
          <li>Pages visited and time spent on our site</li>
          <li>Referring website and search terms used</li>
          <li>Download history and preferences</li>
        </ul>
      </section>

      <section id="how-we-use-information" role="region" aria-labelledby="how-we-use-information-heading">
        <h2 id="how-we-use-information-heading">How We Use Your Information</h2>
        <p>We use the information we collect for various purposes, including:</p>
        
        <h3 id="service-provision">Service Provision</h3>
        <ul>
          <li>Providing and maintaining our wallpaper service</li>
          <li>Processing your requests and transactions</li>
          <li>Personalizing your experience and content recommendations</li>
          <li>Managing your account and preferences</li>
        </ul>

        <h3 id="communication">Communication</h3>
        <ul>
          <li>Responding to your inquiries and support requests</li>
          <li>Sending important service updates and notifications</li>
          <li>Providing marketing communications (with your consent)</li>
          <li>Conducting surveys and gathering feedback</li>
        </ul>

        <h3 id="improvement-and-analytics">Service Improvement and Analytics</h3>
        <ul>
          <li>Analyzing usage patterns to improve our services</li>
          <li>Monitoring and preventing fraud and abuse</li>
          <li>Ensuring technical functionality and security</li>
          <li>Developing new features and services</li>
        </ul>
      </section>

      <section id="information-sharing" role="region" aria-labelledby="information-sharing-heading">
        <h2 id="information-sharing-heading">Information Sharing and Disclosure</h2>
        <p>We do not sell, trade, or otherwise transfer your personal information to third parties, except in the following circumstances:</p>

        <h3 id="service-providers">Service Providers</h3>
        <p>We may share your information with trusted third-party service providers who assist us in operating our website and providing our services:</p>
        <ul>
          <li><strong>Firebase (Google):</strong> For authentication, database, and hosting services</li>
          <li><strong>Cloudinary:</strong> For image storage, processing, and delivery</li>
          <li><strong>Google AdSense:</strong> For advertising services (see Advertising section below)</li>
        </ul>

        <h3 id="legal-requirements">Legal Requirements</h3>
        <p>We may disclose your information if required to do so by law or in response to:</p>
        <ul>
          <li>Valid legal processes (subpoenas, court orders)</li>
          <li>Government requests or investigations</li>
          <li>Protecting our rights, property, or safety</li>
          <li>Preventing fraud or illegal activities</li>
        </ul>

        <h3 id="business-transfers">Business Transfers</h3>
        <p>In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of the business transaction. We will notify you of any such change in ownership or control.</p>
      </section>

      <section id="data-storage-security" role="region" aria-labelledby="data-storage-security-heading">
        <h2 id="data-storage-security-heading">Data Storage and Security</h2>
        
        <h3 id="data-security">Data Security</h3>
        <p>We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. These measures include:</p>
        <ul>
          <li>Encryption of data in transit and at rest</li>
          <li>Regular security assessments and updates</li>
          <li>Access controls and authentication mechanisms</li>
          <li>Secure hosting infrastructure</li>
        </ul>

        <h3 id="data-retention">Data Retention</h3>
        <p>We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law. When we no longer need your information, we will securely delete or anonymize it.</p>

        <h3 id="international-transfers">International Data Transfers</h3>
        <p>Your information may be transferred to and processed in countries other than your own. We ensure that such transfers comply with applicable data protection laws and implement appropriate safeguards.</p>
      </section>

      <section id="cookies-tracking" role="region" aria-labelledby="cookies-tracking-heading">
        <h2 id="cookies-tracking-heading">Cookies and Tracking Technologies</h2>
        
        <h3 id="what-are-cookies">What Are Cookies</h3>
        <p>Cookies are small text files stored on your device when you visit our website. We use cookies and similar tracking technologies to enhance your browsing experience and analyze site usage.</p>

        <h3 id="types-of-cookies">Types of Cookies We Use</h3>
        <ul>
          <li><strong>Essential Cookies:</strong> Necessary for basic website functionality and security</li>
          <li><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website</li>
          <li><strong>Preference Cookies:</strong> Remember your settings and preferences</li>
          <li><strong>Advertising Cookies:</strong> Used to deliver relevant advertisements (see below)</li>
        </ul>

        <h3 id="managing-cookies">Managing Cookies</h3>
        <p>You can control and manage cookies through your browser settings. However, disabling certain cookies may affect the functionality of our website. Most browsers allow you to:</p>
        <ul>
          <li>View and delete cookies</li>
          <li>Block cookies from specific sites</li>
          <li>Block third-party cookies</li>
          <li>Clear all cookies when you close your browser</li>
        </ul>
      </section>

      <section id="third-party-services" role="region" aria-labelledby="third-party-services-heading">
        <h2 id="third-party-services-heading">Third-Party Services</h2>
        
        <h3 id="google-adsense">Google AdSense</h3>
        <p>We use Google AdSense to display advertisements on our website. Google AdSense may use cookies and other tracking technologies to:</p>
        <ul>
          <li>Display personalized advertisements based on your interests</li>
          <li>Measure ad performance and effectiveness</li>
          <li>Prevent fraud and abuse</li>
        </ul>
        <p>You can opt out of personalized advertising by visiting <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">Google's Ad Settings</a> or through the <a href="http://www.aboutads.info/choices/" target="_blank" rel="noopener noreferrer">Digital Advertising Alliance's opt-out page</a>.</p>

        <h3 id="firebase-services">Firebase Services</h3>
        <p>We use Google Firebase for various backend services including:</p>
        <ul>
          <li><strong>Authentication:</strong> Managing user accounts and login</li>
          <li><strong>Firestore Database:</strong> Storing application data</li>
          <li><strong>Cloud Storage:</strong> Storing user-uploaded content</li>
          <li><strong>Analytics:</strong> Understanding app usage and performance</li>
        </ul>
        <p>Firebase's data processing is governed by Google's Privacy Policy and Firebase's specific privacy practices.</p>

        <h3 id="cloudinary">Cloudinary</h3>
        <p>We use Cloudinary for image storage, processing, and delivery. Cloudinary may process and store wallpaper images you upload or view. Their data processing is governed by Cloudinary's Privacy Policy.</p>
      </section>

      <section id="user-rights" role="region" aria-labelledby="user-rights-heading">
        <h2 id="user-rights-heading">Your Rights and Choices</h2>
        
        <h3 id="account-information">Account Information</h3>
        <p>If you have an account with us, you can:</p>
        <ul>
          <li>Access and update your profile information</li>
          <li>Change your communication preferences</li>
          <li>Delete content you have uploaded</li>
          <li>Deactivate your account</li>
        </ul>

        <h3 id="data-rights">Data Rights</h3>
        <p>Depending on your location, you may have the following rights regarding your personal information:</p>
        <ul>
          <li><strong>Access:</strong> Request a copy of the personal information we hold about you</li>
          <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
          <li><strong>Deletion:</strong> Request deletion of your personal information</li>
          <li><strong>Portability:</strong> Request transfer of your data to another service</li>
          <li><strong>Restriction:</strong> Request limitation of processing in certain circumstances</li>
          <li><strong>Objection:</strong> Object to processing based on legitimate interests</li>
        </ul>

        <h3 id="exercising-rights">Exercising Your Rights</h3>
        <p>To exercise any of these rights, please contact us at <a href="mailto:collinsodeny@gmail.com">collinsodeny@gmail.com</a>. We will respond to your request within the timeframe required by applicable law.</p>
      </section>

      <section id="gdpr-compliance" role="region" aria-labelledby="gdpr-compliance-heading">
        <h2 id="gdpr-compliance-heading">GDPR Compliance (EU Users)</h2>
        
        <h3 id="legal-basis">Legal Basis for Processing</h3>
        <p>For users in the European Union, we process your personal information based on the following legal grounds:</p>
        <ul>
          <li><strong>Consent:</strong> When you have given clear consent for specific processing activities</li>
          <li><strong>Contract:</strong> When processing is necessary to provide our services</li>
          <li><strong>Legal Obligation:</strong> When we must process data to comply with legal requirements</li>
          <li><strong>Legitimate Interest:</strong> When we have a legitimate business interest that doesn't override your rights</li>
        </ul>

        <h3 id="data-protection-rights">Enhanced Data Protection Rights</h3>
        <p>As an EU resident, you have additional rights under the GDPR:</p>
        <ul>
          <li>Right to withdraw consent at any time</li>
          <li>Right to lodge a complaint with your local data protection authority</li>
          <li>Right to receive information about data breaches that may affect you</li>
          <li>Right to data protection by design and by default</li>
        </ul>

        <h3 id="data-transfers">Data Transfers Outside the EU</h3>
        <p>When we transfer your data outside the EU, we ensure adequate protection through:</p>
        <ul>
          <li>Adequacy decisions by the European Commission</li>
          <li>Standard Contractual Clauses (SCCs)</li>
          <li>Binding Corporate Rules</li>
          <li>Certification schemes and codes of conduct</li>
        </ul>
      </section>

      <section id="childrens-privacy" role="region" aria-labelledby="childrens-privacy-heading">
        <h2 id="childrens-privacy-heading">Children's Privacy</h2>
        <p>Our service is not intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately.</p>
        <p>If we discover that we have collected personal information from a child under 13 without parental consent, we will take steps to remove that information from our servers promptly.</p>
        <p>For users between 13 and 18, we recommend parental guidance when using our services and sharing personal information online.</p>
      </section>

      <section id="changes-to-policy" role="region" aria-labelledby="changes-to-policy-heading">
        <h2 id="changes-to-policy-heading">Changes to This Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time to reflect changes in our practices, technology, legal requirements, or other factors. When we make changes, we will:</p>
        <ul>
          <li>Update the "Last Updated" date at the top of this policy</li>
          <li>Notify you of significant changes through our website or email</li>
          <li>Provide a summary of key changes when appropriate</li>
          <li>Give you the opportunity to review the updated policy</li>
        </ul>
        <p>We encourage you to review this Privacy Policy periodically to stay informed about how we protect your information.</p>
      </section>

      <section id="contact-information" role="region" aria-labelledby="contact-information-heading">
        <h2 id="contact-information-heading">Contact Information</h2>
        <p>If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:</p>
        <div class="contact-details">
          <p><strong>Email:</strong> <a href="mailto:privacy@wallpaperhub.com">privacy@wallpaperhub.com</a></p>
          <p><strong>General Support:</strong> <a href="mailto:support@wallpaperhub.com">support@wallpaperhub.com</a></p>
          <p><strong>Data Protection Officer:</strong> <a href="mailto:dpo@wallpaperhub.com">dpo@wallpaperhub.com</a></p>
        </div>
        <p>We will make every effort to respond to your inquiries promptly and address any concerns you may have about your privacy and data protection.</p>
      </section>
    </div>
  </LegalPageLayout>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import LegalPageLayout from '@/components/LegalPageLayout.vue'
import { seoManager } from '@/utils/seoUtils'

// Dynamic last updated date - in a real app, this could come from a config file or API
const lastUpdated = '2024-01-15'

onMounted(() => {
  // Set comprehensive SEO tags using the new SEO manager
  const metaTags = {
    title: 'Privacy Policy - WallpaperHub',
    description: 'Learn how WallpaperHub collects, uses, and protects your personal information. Our comprehensive privacy policy covers data collection, cookies, third-party services, and your rights under GDPR.',
    keywords: 'privacy policy, data protection, GDPR, cookies, personal information, wallpaper app, data collection, user rights, third-party services, AdSense privacy',
    robots: 'index, follow',
    ogType: 'website'
  };
  
  seoManager.applyMetaTags(metaTags);
})
</script>

<style scoped>
.privacy-policy-content {
  /* Additional styling specific to privacy policy if needed */
}

.contact-details {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin: 1rem 0;
}

.contact-details p {
  margin: 0.5rem 0;
}

.contact-details p:first-child {
  margin-top: 0;
}

.contact-details p:last-child {
  margin-bottom: 0;
}

/* Ensure proper spacing for sections */
section {
  margin-bottom: 2rem;
}

section:last-child {
  margin-bottom: 0;
}

/* Style for external links */
a[target="_blank"]::after {
  content: " ↗";
  font-size: 0.8em;
  opacity: 0.7;
}
</style>